export class NotificationRequestContractError extends Error {
  constructor(detail) {
    super(`Invalid notification request: ${detail}`);
    this.name = 'NotificationRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}

const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const isId = value => typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);
const scopes = new Set(['personal', 'community', 'multi-community']);
const targets = new Set(['Activity', 'Event', 'Media', 'User', 'Post', 'Session', 'VenueRequest']);
const isDate = value => {
  if (typeof value !== 'string' || !value.trim() || !Number.isFinite(Date.parse(value))) return false;
  const calendar = /^(\d{4}-\d{2}-\d{2})(?:$|T)/.exec(value.trim());
  if (!calendar) return true;
  const date = new Date(`${calendar[1]}T00:00:00.000Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === calendar[1];
};
const isInteger = value => (typeof value === 'number' || typeof value === 'string' && /^\d+$/.test(value))
  && Number.isSafeInteger(Number(value));

export function readNotificationCreateRequest(body) {
  if (!isRecord(body) || typeof body.type !== 'string' || !body.type.trim()
    || !isId(body.actor) || !isId(body.recipientCommunity) || !scopes.has(body.scope)
    || body.target != null && !isId(body.target)
    || body.targetType != null && !targets.has(body.targetType)
    || body.target != null && !targets.has(body.targetType)
    || body.additionalData !== undefined && (!isRecord(body.additionalData)
      || body.additionalData.caption !== undefined && typeof body.additionalData.caption !== 'string')) {
    throw new NotificationRequestContractError('expected a type, actor, community, scope and valid optional target/data.');
  }
  return body;
}

export function readNotificationId(id) {
  if (!isId(id)) throw new NotificationRequestContractError('expected a notification ObjectId.');
  return id;
}

export function readNotificationListRequest(query) {
  if (!isRecord(query)
    || ['eventType', 'userCommunityId'].some(key => query[key] !== undefined && !isId(query[key]))
    || ['startDate', 'endDate'].some(key => query[key] !== undefined && !isDate(query[key]))
    || ['limit', 'offset', 'since'].some(key => query[key] !== undefined && (!isInteger(query[key]) || Number(query[key]) < 0
      || key === 'since' && !Number.isFinite(new Date(Number(query[key])).getTime())))
    || query.treasury !== undefined && !['true', 'false', true, false].includes(query.treasury)) {
    throw new NotificationRequestContractError('invalid notification filters.');
  }
  const start = query.since !== undefined ? Number(query.since) : query.startDate !== undefined ? Date.parse(query.startDate) : null;
  if (start !== null && query.endDate !== undefined && start > Date.parse(query.endDate)) {
    throw new NotificationRequestContractError('notification date range is reversed.');
  }
  return query;
}
